import { render } from "./Switch.vue?vue&type=template&id=dad3f3b8&scoped=true"
import script from "./Switch.vue?vue&type=script&lang=js"
export * from "./Switch.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-dad3f3b8"

export default script